import React, { lazy, Suspense, startTransition, useEffect, useState, } from "react";
import { useLocation, useNavigate, Routes, Route, } from "react-router-dom";
import ScrollToTop from "../components/common/ScrollToTop";
import i18n from "../i18n";

import { useTranslation } from "react-i18next";
import PrivateRoute from "./PrivateRoute";
import { useSelector } from "react-redux";
import Loader from "../components/common/Loader";
import PublicRoute from "./PublicRoute";
import usesRouteUrls from "../utils/PathName/usesUrlsArray";
import musicRouteUrls from "../utils/PathName/musicRouteUrls";
// Lazy-loaded components
const Login = React.lazy(() => import("../components/auth/Login"));
const Signup = React.lazy(() => import("../components/auth/Signup"));
const NotFound = React.lazy(() => import("../components/404"));
const ForgotPassword = React.lazy(() => import("../components/auth/ForgotPassword"));
const ResetPassword = React.lazy(() => import("../components/auth/ResetPassword"));
const AccountNavigation = React.lazy(() => import("../pages/my-profile/AcountNavigatio"));
// const CategoryIndex = React.lazy(() => import("../pages/HeaderElements/Learn/Category/Index"));
const CategoryIndex = React.lazy(() => import("../pages/BlogCategory/BlogCategory"));
const Success = React.lazy(() => import("../components/paymentSection/afterPayment/Success"));
const Cancel = React.lazy(() => import("../components/paymentSection/afterPayment/Cancle"));
const AuthorDetails = React.lazy(() => import("../pages/HeaderElements/Learn/Blog/AuthorDetails"));
// const LicenseTerms = React.lazy(() => import("../pages/FooterElements/licenseTerms/LicenseTerms"));
const LicenseTerms = React.lazy(() => import("../pages/Licenses/License"));
// const PrivacyPolicy = React.lazy(() => import("../pages/FooterElements/privacyPolicy/PrivacyPolicy"));
const PrivacyPolicy = React.lazy(() => import("../pages/PolicyTemplate/Policy"));
// const TermsOfUse = React.lazy(() => import("../pages/FooterElements/termsOfUse/TermsOfUse"));
const TermsOfUse = React.lazy(() => import("../pages/TermsConditions/Terms"));
const LicencesTerms = React.lazy(() => import("../pages/licences-terms/LicencesTerms"));

const Press = React.lazy(() => import("../pages/FooterElements/press/Press"));
const BackgroundMusic = React.lazy(() => import("../pages/FooterElements/BackgroundMusic/BackgroundMusic"));
const MusicFor = React.lazy(() => import("../pages/FooterElements/musicFor/MusicFor"));
const NonCopyrightMusic = React.lazy(() => import("../pages/FooterElements/nonCopyrightMusic/NonCopyrightMusic"));
const Header = lazy(() => import("../components/Header"));
const Footer = lazy(() => import("../components/Footer"));
const Home = lazy(() => import("../pages/Home/Home"));
const Music = lazy(() => import("../pages/HeaderElements/music/Music"));
// const License = lazy(() => import("../pages/HeaderElements/Licenses"));
const License = lazy(() => import("../pages/Licenses/License"));

// const AboutUs = lazy(() => import("../pages/HeaderElements/About/AboutUs"));
const AboutUs = lazy(() => import("../pages/AboutUs/About"));
// const Contact = lazy(() => import("../pages/HeaderElements/Contact/Contact"));
const Contact = lazy(() => import("../pages/ContactUS/Contact"));
const Uses = lazy(() => import("../pages/HeaderElements/Uses/Uses"));
const UsesDetails = lazy(() => import("../pages/HeaderElements/Uses/components/UsesDetails"));
// const Blog = lazy(() => import("../pages/HeaderElements/Learn/Blog/Blog"));
const Blog = lazy(() => import("../pages/BlogHome/BlogHome"));
// const BlogDetails = lazy(() => import("../components/common/BlogDetails"));
const BlogDetails = lazy(() => import("../pages/BlogDetails/BlogDetails"));
const CategotyDetails = lazy(() => import("../pages/HeaderElements/music/musicCategoryDetails/CategotyDetails"));
const AllMusic = lazy(() => import("../pages/HeaderElements/music/AllMusic/AllMusic"));
const RoylityFreeMusicPage = lazy(()=> import ("../components/Royalty-Free-Music"))

const Router = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [querrystring, setQuerryString] = useState("");
  const { t } = useTranslation();

  const authToken = useSelector((state) => {
    return state.auth.authToken;
  });
  useEffect(() => {
    const cleanPath = location.pathname.replace(/\/$/, "");
    const withSlash = location.pathname.endsWith("/")
  ? location.pathname
  : location.pathname + "/";
    // Wrap the transition in startTransition to prevent blocking UI.
    startTransition(() => {
      let identifyLanguageFromQuerry = location?.pathname.split("/");
      if (identifyLanguageFromQuerry[1] == "es") {
        setQuerryString(location.pathname);
        i18n.changeLanguage("es");
      } else if (identifyLanguageFromQuerry[1] == "fr") {
        setQuerryString(location.pathname);
        i18n.changeLanguage("fr");
      } else {
        setQuerryString(location.pathname);
        i18n.changeLanguage("en");
      }
    });
    if (
      location.pathname=="/background-music/facts-video/" ||
      location.pathname=="/non-copyright-music/cricket-videos/" ||
      location.pathname == "/uses" ||
      location.pathname == "/es/usos" ||
      location.pathname == "/fr/usages" ||
      usesRouteUrls?.includes(withSlash) ||
      musicRouteUrls?.includes(withSlash)
    ) {
      window.location.assign("https://app.legismusic.com/music")
    }
    if (
      location.pathname == "/licenses"
     ) {
      navigate("/pricing")
     }
     if (location.pathname == "/es/licencias") {
      navigate("/precios")
     }
     if (location.pathname == "fr/licences")
      {
        navigate("/tarification")
      }
    if (
      location.pathname == "contact-us"
     ) {
      navigate('/contact')
     }
    if ( location.pathname == "contactez-nous" ) {
      navigate('contacte-nous')
    } 
     
  }, []);

  useEffect(() => {
    let querryStringArray = querrystring?.split("/");
    if (querryStringArray?.length > 2) {
      navigate(querrystring);
    } else {
    }
  }, [querrystring]);

  const currentLanguage = i18n.language;
  const languagePrefix =
    currentLanguage === "en" ||
      currentLanguage === "en-GB" ||
      currentLanguage === "en-US"
      ? ""
      : `/${currentLanguage}`;

  const routes = [
    {
      path: `${languagePrefix}/`,
      element: <Home />,
    },
    {
      path: `${languagePrefix}/${t("pricingUrl")}`,
      element: <License />,
      pathname: ["pricing", "precios", "tarification"],
    },
    {
      path: `${languagePrefix}/${t("aboutusUrl")}`,
      element: <AboutUs />,
      pathname: ["about-us", "nuestra-historia", "qui-sommes-nous"],
    },
    {
      path: `${languagePrefix}/${t("contactUrl")}`,
      element: <Contact />,
      pathname: ["contact", "contacto", "contacte-nous"],
    },
    {
      path: `${languagePrefix}/${t("blogUrl")}`,
      element: <Blog />,
      pathname: ["blog", "blog-musica", "blog-de-musique"],
    },
    {
      path: `${languagePrefix}/*`,
      element: <NotFound />,
    },
    {
      path: `${languagePrefix}/${t("privacyUrl")}`,
      element: <PrivacyPolicy />,
      pathname: ["privacy", "privacidad", "confidentialite"],
    },
    {
      path: `${languagePrefix}/${t("termsUrl")}`,
      element: <TermsOfUse />,
      pathname: ["terms", "terminos", "termes"],
    },
    {
      path: `${languagePrefix}/${t("terms_of_Use")}`,
      element: <LicencesTerms />,
      pathname: ["terms-of-use", "terminos-de-uso", "conditions-dutilisation"],
    },

  ];
  const languageRoutes = [
    { lang: 'category', path: '/category/:learncategoryName' },
    { lang: 'categoria', path: '/categoria/:learncategoryName' },
    { lang: 'categorie', path: '/categorie/:learncategoryName' },
    { lang: 'author', path: '/author/:authorName' },
    { lang: 'autor', path: '/autor/:authorName' },
    { lang: 'auteur', path: '/auteur/:authorName' },

    { lang: 'royalty-free-music', path: '/royalty-free-music/:royaltyFreeMusic' },
    { lang: 'royalty-free-musica', path: '/royalty-free-musica/:royaltyFreeMusic' },
    { lang: 'royalty-free-musique', path: '/royalty-free-musique/:royaltyFreeMusic' },

  ];


  const pathSegments = location.pathname.split("/").filter(Boolean);
  const langMatch = languageRoutes.some(
    (route) => pathSegments[pathSegments.length - 2] === route.lang
  );
  const pageSegment = pathSegments[pathSegments.length - 1];
  const pathnameKey = routes.find((route) =>
    route.pathname?.some((path) => path === pageSegment)
  );

  useEffect(() => {
    if (!langMatch && pathnameKey) {
      navigate(pathnameKey.path, { replace: true });
    }
  }, [languagePrefix, navigate, t]);

  return (
    <>
      <ScrollToTop>
        <Suspense fallback={<Loader />}>
          <Header />
        </Suspense>
        <Routes>
          {/* Public Auth Pages */}
          <Route
              path="/login"
              element={
                <PublicRoute
                  element={<Suspense fallback={<Loader />}><Login />   </Suspense>}
                  authToken={authToken}
                // redirectTo="/"
                />
              }
            />
            <Route
              path="/signup"
              element={
                <PublicRoute
                  element={<Suspense fallback={<Loader />}><Signup /></Suspense>}
                  authToken={authToken}
                // redirectTo="/"
                />
              }
            />
            <Route
              path="/forgot-password"
              element={
                <PublicRoute
                  element={<Suspense fallback={<Loader />}><ForgotPassword /></Suspense>}
                  authToken={authToken}
                // redirectTo="/"
                />
              }
            />
            <Route
              path="/reset-password/:token"
              element={
                <PublicRoute
                  element={<Suspense fallback={<Loader />}><ResetPassword /></Suspense>}
                  authToken={authToken}
                // redirectTo="/"
                />
              }
            />
            {routes.map((route, i) => {
              if (route.authenticated) {
                return (
                  <Route
                    key={i}
                    path={route.path}
                    element={
                      <PrivateRoute
                        element={
                          <Suspense fallback={<Loader />}>
                            {route.element}
                          </Suspense>
                        }
                        authenticated={route.authenticated}
                        authToken={authToken}
                      />
                    }
                  />
                );
              }
              return (
                <Route
                  key={i}
                  path={route.path}
                  element={
                    <Suspense fallback={<Loader />}>{route.element}</Suspense>
                  }
                />
              );
            })}
            {languageRoutes.map((route) => {
              return (
                <Route
                  key={route.lang}
                  path={`${languagePrefix}${route.path}`}
                  element={
                    <Suspense fallback={<Loader />}>
                      {(route.lang == "category" || route.lang == "categoria" || route.lang == "categorie") ? <CategoryIndex /> : (route.lang == "author" || route.lang == "autor" || route.lang == "auteur") ? <AuthorDetails /> : (route.lang == "royalty-free-music" || route.lang == "royalty-free-musica" || route.lang == "royalty-free-musique") ? <RoylityFreeMusicPage/> : <NotFound />}
                    </Suspense>
                  }
                />
              )
            })}

            <Route
              path={`${languagePrefix}/:slug`}
              element={
                <Suspense fallback={<Loader />}>
                  <BlogDetails />
                </Suspense>
              }
            />
       
        </Routes>
        <Suspense fallback={<Loader />}>
          <Footer />
        </Suspense>
      </ScrollToTop>
    </>
  );
};

export default Router;
